import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isSendActivityReportRequestFailure() {
      return getState().isFailure;
    },
    isSendActivityReportRequestPending() {
      return getState().isPending;
    },
    isSendActivityReportRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
